export enum GridClass {
  Body = 'ag-center-cols-clipper',
  BodyScroll = 'ag-center-cols-viewport',
  RootWrapper = 'ag-root-wrapper-body',
  Root = 'ag-root',
  CellReact = 'cell-react',
  PaginationContainer = 'ag-paging-panel',
}
